import { usePushNotificationsStore } from '~/stores/pushNotifications'

export const usePushNotifications = () => {
  const store = usePushNotificationsStore()

  // NOTA: Funções de envio de notificação foram removidas.
  // Todas as notificações agora são disparadas exclusivamente pelo backend
  // para evitar duplicações e manter arquitetura consistente.

  // Verifica e solicita permissão se necessário
  const ensurePermission = async () => {
    if (!store.hasPermission) {
      const granted = await store.requestPermission()
      if (!granted) {
        throw new Error('Permissão de notificação negada')
      }
    }
    return true
  }

  // Inicializa o sistema de notificações
  const initialize = async () => {
    await store.initialize()

    // Se o usuário já tinha permissão antes, mantém habilitado
    if (store.hasPermission && !store.enabled) {
      store.enabled = true
      await store.registerForPushNotifications()
    }
  }

  return {
    // Store
    store: readonly(store),

    // Estado
    isAvailable: computed(() => store.isAvailable),
    hasPermission: computed(() => store.hasPermission),
    isEnabled: computed(() => store.enabled),
    unreadCount: computed(() => store.unreadCount),

    // Ações básicas
    initialize,
    ensurePermission,
    requestPermission: store.requestPermission,
    disable: store.disableNotifications,
    testNotification: store.testNotification,
    sendWelcomeNotification: store.sendWelcomeNotification,

    // NOTA: Funções de envio removidas - backend controla todos os envios

    // Gerenciamento de notificações
    markAsRead: store.markAsRead,
    markAllAsRead: store.markAllAsRead,
    clearHistory: store.clearHistory,

    // Agendamento
    scheduleNotification: store.scheduleNotification,
    cancelScheduledNotification: store.cancelScheduledNotification,

    // Configurações
    updateSettings: store.updateSettings,
  }
}
